import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { User, Register, Login, Office } from './user.model';

@Injectable()
export class UserService {

 // readonly rootUrl = "http://localhost:14055";

  readonly rootUrl = 'http://crmapi.esdinfra.com';  
  httpOptions: any;

  constructor(private http: HttpClient) {
    let accesstoken = localStorage.getItem('accessToken');
    if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accesstoken,
          'No-Auth': 'True'
        })
      };
    }
  }

  getAllowedPages() {
    debugger
    let accesstoken = localStorage.getItem('accessToken');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.rootUrl + '/api/AllowedPages', this.httpOptions);
  }
  userAuthentication(user?: Login) {
    debugger;
    var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password";
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
    }
    return this.http.post(this.rootUrl + '/token', data, httpOptions);
  }
  getAllRoles(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    debugger;
    return this.http.get(this.rootUrl + '/api/Claims/' + roleId,this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Roles/' + roleId, this.httpOptions);
  }
  getUserForTheId(Id: string) {
    return this.http.get(this.rootUrl + '/api/Users/' + Id, this.httpOptions);
  }
  getOfficeForTheId(OfficeId: string) {
    return this.http.get(this.rootUrl + '/api/Offices/' + OfficeId, this.httpOptions);
  }
  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  GetAllRoleNames() {
    return this.http.get(this.rootUrl + '/api/Roles/GetAllOffices/', this.httpOptions);
  }
  getAllDistrictName() {
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrict', this.httpOptions);
  }
  GetAllStates() {
    return this.http.get(this.rootUrl + '/api/Users/GetAllStates', this.httpOptions);
  }
  GetAllDistrictById(ID: any) {
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrictById/' + ID, this.httpOptions);
  }
  getRolesforSelectedOffice() {
    return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice', this.httpOptions);
  }
  GetAllOffices(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  registerUser(register: Register) {
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }
  registerCustomer(register: Register) {
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }
  VerifyMobileNo(Mob_No: any) {
    return this.http.put(this.rootUrl + '/api/Users/VerifyMobileNo/' + Mob_No + "/", this.httpOptions);
  }
  createRole(user: User) {
    return this.http.post(this.rootUrl + '/api/Roles/Create', user, this.httpOptions);
  }
  updateRole(user: User, roleId: string) {
    return this.http.put(this.rootUrl + '/api/Roles/Update/' + roleId, user, this.httpOptions);
  }
  searchRoles(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  searchUsers(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  searchOffices(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  updateOffice(office: Office, OfficeId: string) {
    return this.http.put(this.rootUrl + '/api/Offices/Update/' + OfficeId, office, this.httpOptions);
  }
  saveClaims(claimsList, roleId) {
    return this.http.put(this.rootUrl + '/api/Claims/' + roleId + '/assignClaims', claimsList, this.httpOptions);
  }
  CreateOffice(office: Office) {
    return this.http.post(this.rootUrl + '/api/Offices/Create', office, this.httpOptions);
  }
  changePassword(userDetails: any) {
    return this.http.post(this.rootUrl + '/api/Account/ChangePassword', userDetails, this.httpOptions);
  }
  changePasswordForTheId(userDetails: any) {
    return this.http.put(this.rootUrl + '/api/Account/Update', userDetails, this.httpOptions);
  }
  deleteRole(id: string) {
    return this.http.put(this.rootUrl + '/api/Roles/Delete/' + id, this.httpOptions);
  }
  activateInactivateUser(id: string) {
    return this.http.put(this.rootUrl + '/api/Users/ActivateInactivate/' + id, null, this.httpOptions);
  }
  activateInactivateRoles(id: string) {
    return this.http.put(this.rootUrl + '/api/Roles/ActivateInactivate/' + id, null, this.httpOptions);
  }
  activateInactivateOffices(id: string) {
    return this.http.put(this.rootUrl + '/api/Offices/ActivateInactivate/' + id, null, this.httpOptions);
  }

 
  getEmpList(id) {
    debugger;
    return this.http.get(this.empList + '/' + id);
  }
  

  empList: any = [
    { 'emp_code': '1032', 'name': 'Kishore',  'phone': '947489485', 'dob': '01/09/1994','website': 'www.google.com','glaccount':'90909','category':'yes', 'doj': '01-09-2020', 'status': 'Active' },
    { 'emp_code': '1033', 'name': 'Vamshi', 'phone': '947489485','dob': '01/09/1995','website': 'www.google.com','glaccount':'90909','category':'yes',  'doj': '01-11-2020', 'status': 'Active' },
    { 'emp_code': '1034', 'name': 'Madhu', 'phone': '947489485','dob': '01/09/1992','website': 'www.google.com','glaccount':'90909','category':'yes',  'doj': '01-09-2018', 'status': 'Active' },
    { 'emp_code': '1035', 'name': 'Krishna', 'phone': '947489485','dob': '01/09/1990','website': 'www.google.com','glaccount':'90909','category':'yes',  'doj': '01-09-2016', 'status': 'Active' }
  ];

  getData()
  {
     return this.http.get(this.empList);
  }

   
  //vendor
  
  GetAllDistricts() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Vendor/GetDistrictDetails', this.httpOptions);
  }
  GetAllStatelist() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Vendor/GetStateModelDetails', this.httpOptions);
  }
  GetAllCategorylist() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Vendor/GetCategoryDetails', this.httpOptions);
  }
  
  PostVendor(udm) {
    debugger;
    return this.http.post(this.rootUrl + '/api/Vendor/CreateVendor', udm, this.httpOptions);
  }
  
  GetAllVendorDetails() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Vendor/GetAllVendor',this.httpOptions);
  } 

  
  GetByIdVendor(DOC_NOs) {
    debugger;
    return this.http.get(this.rootUrl + '/api/Vendor/GetByIdVendor/' + DOC_NOs, this.httpOptions);
  }

  UpdateVendor(udm, DOC_NOs) {
    debugger;
    return this.http.put(this.rootUrl + '/api/Vendor/UpdateVendor/' + DOC_NOs, udm, this.httpOptions);
  }
  DeleteVendor(DOC_NOs) {
    debugger;
    return this.http.put(this.rootUrl + '/api/Vendor/DeleteVendor/' + DOC_NOs,null, this.httpOptions);
  }



  //employee
  GetAlldepart() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Employee/Getdept', this.httpOptions);
  }
  GetAllSECTIONLIST() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Employee/Getsec', this.httpOptions);
  }
  // GetSectionDetails() {
  //   return this.http.get(this.rootUrl + '/api/DivisionMaster/GetSectionDetails', this.httpOptions);
  // }
  GetAllDivisioname() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Employee/GetDivisionForDepartmentDetails', this.httpOptions);
  }

  GetDesignationlist() {
    return this.http.get(this.rootUrl + '/api/Employee/GetDesignationlist', this.httpOptions);
  }


  GetEmployeeTypelist() {
    return this.http.get(this.rootUrl + '/api/Employee/GetEmployeeType', this.httpOptions);
  }

  PostEmployee(udm) {
    debugger;
    return this.http.post(this.rootUrl + '/api/Employee/CreateEmployee', udm, this.httpOptions);
  }

  // uploadImagesFile(data) {
  //   debugger
  //   return this.http.post(this.rootUrl + '/api/Employee/images', data);
  // }

  uploadImagesFilePhoto(data) {
    return this.http.post(this.rootUrl + '/api/Vendor/images1', data);
  }


  GetAllEmployeeDetails() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Employee/GetEmployee',this.httpOptions);
  } 
  GetByIdEmployee(EMP_ID) {
    debugger;
    return this.http.get(this.rootUrl + '/api/Employee/GetByIdEmployee/' + EMP_ID, this.httpOptions);
  }

  uploadImageforaadhar(data) {
    debugger;
    return this.http.post(this.rootUrl + '/api/Vendor/images1', data);
  }


  UpdateEmployee(udm, EMP_ID) {
    debugger;
    return this.http.put(this.rootUrl + '/api/Employee/UpdateEmployee/' + EMP_ID, udm, this.httpOptions);
  }


  DeleteEmployee(EMP_ID) {
    debugger;
    return this.http.put(this.rootUrl + '/api/Employee/DeleteEmployee/' + EMP_ID,null, this.httpOptions);
  }

  
//product

GetByIdsubcat(Cat_Name) {
  debugger;
  return this.http.get(this.rootUrl + '/api/Product/GetsubProductCategory/' + Cat_Name, this.httpOptions);
}

loadallcategorydetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Product/GetProductCategory', this.httpOptions);
}

GetAllUOMlist() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Product/GetAllUOMlist', this.httpOptions);
}
GetManufacturerDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Product/GetManufacturerDetails', this.httpOptions);
}
PostProduct(udm) {
  debugger;
  return this.http.post(this.rootUrl + '/api/Product/CreateProduct', udm, this.httpOptions);
}
GetAllProductDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Product/GetAllProduct',this.httpOptions);
} 

GetGSTDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Product/GetGSTDetails', this.httpOptions);
}
GetByIdProduct(DOC_NOs) {
  debugger;
  return this.http.get(this.rootUrl + '/api/Product/GetByIdProduct/' + DOC_NOs, this.httpOptions);
}


GetGSTfortheId(GST_RATE: any) {
  return this.http.get(this.rootUrl + '/api/Product/GetGSTByid/' + GST_RATE, this.httpOptions);
}
UpdateProduct(udm, DOC_NOs) {
  debugger;
  return this.http.put(this.rootUrl + '/api/Product/UpdateProduct/' + DOC_NOs, udm, this.httpOptions);
}



//lead
GetAllIndustries() {
  return this.http.get(this.rootUrl + '/api/Lead/GetAllIndustries', this.httpOptions);
}

GetAllRatings() {
  return this.http.get(this.rootUrl + '/api/Lead/GetAllRatings', this.httpOptions);
}

GetAllLeadSource() {
  return this.http.get(this.rootUrl + '/api/Lead/GetAllLeadSource', this.httpOptions);
}

GetAllLeadStatus() {
  return this.http.get(this.rootUrl + '/api/Lead/GetAllLeadStatus', this.httpOptions);
}
GetAllLeadCategory() {
  return this.http.get(this.rootUrl + '/api/Lead/GetAllLeadCategory', this.httpOptions);
}
PostLead(udm) {
  debugger;
  return this.http.post(this.rootUrl + '/api/Lead/CreateLead', udm, this.httpOptions);
}

GetAllLeadDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Lead/GetAllLead',this.httpOptions);
} 


  
GetByIdLead(DOC_NOs) {
  debugger;
  return this.http.get(this.rootUrl + '/api/Lead/GetByIdLead/' + DOC_NOs, this.httpOptions);
}


UpdateLead(udm, DOC_NOs) {
  debugger;
  return this.http.put(this.rootUrl + '/api/Lead/UpdateLead/' + DOC_NOs ,udm, this.httpOptions);
}
DeleteLead(DOC_NOs) {
  debugger;
  return this.http.put(this.rootUrl + '/api/Lead/DeleteLead/' + DOC_NOs,null, this.httpOptions);
}

DeleteAssignLead(DOC_NOs) {
  debugger;
  return this.http.put(this.rootUrl + '/api/Lead/DeleteAssignLead/' + DOC_NOs,null, this.httpOptions);
}


//company
uploadImageCompany(data) {
  return this.http.post(this.rootUrl + '/api/CompanyMaster/image', data);
}

PostCompany(udm) {
  return this.http.post(this.rootUrl + '/api/CompanyMaster/CreateCompany', udm, this.httpOptions);
}

GetByIdCompanyModel(Company_Id) {
  return this.http.get(this.rootUrl + '/api/CompanyMaster/GetByIdCompanyModel/' + Company_Id, this.httpOptions);
}
UpdateComapny(udm, Company_Id) {
  return this.http.put(this.rootUrl + '/api/CompanyMaster/UpdateCompany/' + Company_Id, udm, this.httpOptions);
}
DeleteComapny(Company_Id) {
  return this.http.put(this.rootUrl + '/api/CompanyMaster/DeleteComapnydetails/' + Company_Id, null, this.httpOptions);
}

GetAllcompnyForDelete(Company_Id) {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetAllDivisionFordelete/' + Company_Id, this.httpOptions);
}


GetAllCompanydetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/CompanyMaster/GetAllCompanyMaster',this.httpOptions);
} 


 //division and department master
 GetAllDivisionDetails(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetAllDivisionMaster/' + itemsPerPage + "/" + pageNo + "/", this.httpOptions);
}

SearchDivisionmaster(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetAllDivisionOnSearch/' + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/", this.httpOptions);
}

GetCompanyDetailsfor() {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetCompany', this.httpOptions);
}

PostDivision(udm) {
  debugger;
  return this.http.post(this.rootUrl + '/api/DivisionMaster/CreateDivision', udm, this.httpOptions);
}

GetByIdDivision(Division_Id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetByIdDivisionModel/' + Division_Id, this.httpOptions);
}

UpdateDivision(udm, Division_Id) {
  return this.http.put(this.rootUrl + '/api/DivisionMaster/UpdateDivision/' + Division_Id, udm, this.httpOptions);
}

GetAllDivisionDetailsInnerGrid() {
  debugger;
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetDivisionDetails', this.httpOptions);
}

DeleteDivisionDetails(Division_Id) {
  return this.http.put(this.rootUrl + '/api/DivisionMaster/DeleteDivisiondetails/' + Division_Id, null, this.httpOptions);
}

// GetAllDivisioname() {
//   return this.http.get(this.rootUrl + '/api/DivisionMaster/GetDivisionForDepartmentDetails', this.httpOptions);
// }

GetAlldepartmentGrid() {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetDeprtmentDetails', this.httpOptions);
}

PostDept(udm) {
  return this.http.post(this.rootUrl + '/api/DivisionMaster/CreateDept', udm, this.httpOptions);
}

GetByIdDept(Dept_Code) {
  debugger;
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetByIdDEPTModel/' + Dept_Code, this.httpOptions);
}
UpdateDept(udm, Dept_Code) {
  return this.http.put(this.rootUrl + '/api/DivisionMaster/UpdateDEPT/' + Dept_Code, udm, this.httpOptions);
}
// GetAlldepart() {
//   return this.http.get(this.rootUrl + '/api/DivisionMaster/Getdept', this.httpOptions);
// }
// GetAllSECTIONLIST() {
//   return this.http.get(this.rootUrl + '/api/EmpDetails/Getsec', this.httpOptions);
// }

GetByIdSection(Dept_Id) {
  debugger;
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetByIdSection/' + Dept_Id, this.httpOptions);
}
UpdateSection(udm, Dept_Id) {
  return this.http.put(this.rootUrl + '/api/DivisionMaster/UpdateSection/' + Dept_Id, udm, this.httpOptions);
}
GetSectionDetails() {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetSectionDetails', this.httpOptions);
}



UpdateSections(Dept_name, Dept_Id) {
  return this.http.put(this.rootUrl + '/api/DivisionMaster/UpdateSections/' + Dept_name + '/' + Dept_Id, null, this.httpOptions);
}
DeleteDeptails(Dept_Id) {
  return this.http.put(this.rootUrl + '/api/DivisionMaster/DeleteDeptails/' + Dept_Id, null, this.httpOptions);
}

DeleteSectails(Dept_Id) {
  return this.http.put(this.rootUrl + '/api/DivisionMaster/DeleteSectails/' + Dept_Id, null, this.httpOptions);
}

PostSection(udm) {
  return this.http.post(this.rootUrl + '/api/DivisionMaster/CreateSection', udm, this.httpOptions);
}

GetAlldivisionForDelete(DivisionDept_Code) {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetDivisionForDelete/' + DivisionDept_Code, this.httpOptions);
}

GetAlldeprtForDelete(Dept_Id) {
  return this.http.get(this.rootUrl + '/api/DivisionMaster/GetDepartmentForDelete/' + Dept_Id, this.httpOptions);
}


//assign lead
GetAllassignLeadDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Lead/GetAllAssignLead/',this.httpOptions);
} 
GetAllemployees() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Lead/GetAllEmployeeForGrid/', this.httpOptions);
}


//activity
GetActivityCategory() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Activity/GetActivityCategory/', this.httpOptions);
}

GetActivityPriority() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Activity/GetActivityPriority/', this.httpOptions);
}

GetActivityStatus() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Activity/GetActivityStatus/', this.httpOptions);
}

GetActivityLead(){
  debugger;
  return this.http.get(this.rootUrl + '/api/Activity/GetActivityLead/', this.httpOptions);
}
PostActivity(udm) {
  debugger;
  return this.http.post(this.rootUrl + '/api/Activity/CreateActivity', udm, this.httpOptions);
}


GetAllActivity() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Activity/GetAllActivity',this.httpOptions);
} 
GetByIdActivity(DOC_NOs) {
  debugger;
  return this.http.get(this.rootUrl + '/api/Activity/GetByIdActivity/' + DOC_NOs, this.httpOptions);
}


PostAssignLead(DOC_NOs: number, EMPp_ID: number,ASSIGN_DATE:Date) {
  debugger;
  return this.http.post(this.rootUrl + '/api/Lead/CreatAssignLead/'+ DOC_NOs + "/" + EMPp_ID + "/" + ASSIGN_DATE,this.httpOptions);
}
UpdateActivity(udm, DOC_NOs) {
  debugger;
  return this.http.put(this.rootUrl + '/api/Activity/UpdateActivity/' + DOC_NOs ,udm, this.httpOptions);
}


DeleteActivity(DOC_NOs) {
  debugger;
  return this.http.put(this.rootUrl + '/api/Activity/DeleteActivity/' + DOC_NOs,null, this.httpOptions);
}
}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts